/*
 * @Description: 统计中心业务接口
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2023-07-02 23:26:53
 * @LastEditors: Monkey
 * @LastEditTime: 2026-03-15 20:11:50
 */
import config from '@/config';
import http from '@/utils/request';

export default {
  report: {
    preIncPerAnalysis: {
      url: `${config.API_URL}/statistics/project/daily/summary/page`,
      name: '预增业绩分析',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    preIncPerLossAnalysis: {
      url: `${config.API_URL}/statistics/project/daily/loss/summary/list`,
      name: '预增业绩流失情况',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    userPerformance: {
      url: `${config.API_URL}/statistics/user/performance/summary/page`,
      name: '员工实际业绩分析',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    projectPerformance: {
      url: `${config.API_URL}/statistics/project/performance/summary/page`,
      name: '项目实际业绩分析',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    userRecruitmentAnalysis: {
      url: `${config.API_URL}/statistics/user/recruitment/analysis/page`,
      name: '员工招聘数据分析',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    projectRecruitmentAnalysis: {
      url: `${config.API_URL}/statistics/project/recruitment/analysis/page`,
      name: '项目招聘数据分析',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    entryEmployeeSummary: {
      url: `${config.API_URL}/statistics/employee/entry/summary/page`,
      name: '入职人员汇总',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    lossEmployeeSummary: {
      url: `${config.API_URL}/statistics/employee/loss/summary/page`,
      name: '流失人员汇总',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    detail: {
      url: `${config.API_URL}/elv/team/statistics/team/profit/detail/list`,
      name: '获取团队信息，包含收入详情和成本详情',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    profit: {
      url: `${config.API_URL}/elv/team/statistics/team/profit/report`,
      name: '获取费用统计',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    business: {
      url: `${config.API_URL}/elv/team/statistics/team/business/people`,
      name: '获取业务中心统计人数信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    report: {
      url: `${config.API_URL}/elv/team/statistics/team/business/people/report`,
      name: '当日接团统计按业务获取接团人数',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    }
  },
  dashboard: {
    projectStatistics: {
      url: `${config.API_URL}/project/statistics/count`,
      name: '统计我的项目和我的合同',
      get: async function () {
        return await http.get(this.url);
      },
    },
    talentStatistics: {
      url: `${config.API_URL}/customer/talent/statistics/count`,
      name: '统计人才数',
      get: async function () {
        return await http.get(this.url);
      },
    },
    performanceStatistics: {
      url: `${config.API_URL}/project/statistics/monthly-performance`,
      name: '年粒度业绩统计，统计我的业绩和公司业绩',
      get: async function () {
        return await http.get(this.url);
      },
    },
  }
}